<div class="d-flex flex-column" [formGroup]="addressFormGroup">
  <div class="w-100 mb-3">
    <div class="input-label">
      <span
        class="standart-text-required-symbol"
        *ngIf="isFieldRequired('line1')"
        >*
      </span>
      Address 1
    </div>
    <input
      type="text"
      placeholder="Enter Address"
      class="input"
      formControlName="line1"
      maxlength="30"
    />
  </div>
  <div class="w-100 mb-3">
    <div class="input-label">
      <span
        class="standart-text-required-symbol"
        *ngIf="isFieldRequired('line2')"
        >*
      </span>
      address 2
    </div>
    <input
      type="text"
      placeholder="Enter Address"
      class="input"
      formControlName="line2"
      maxlength="30"
    />
  </div>

  <div class="address-wrapper" [class.small]="size === 'small'">
    <div class="">
      <div class="input-label">
        <span
          class="standart-text-required-symbol"
          *ngIf="isFieldRequired('zipcode')"
          >*
        </span>
        Zip
      </div>

      <!-- [addTag]="true" -->
      <ng-select
        [items]="codes"
        [disabled]="addressFormGroup.disabled"
        [(ngModel)]="selectedZipcode"
        bindLabel="code"
        [ngModelOptions]="{ standalone: true }"
        [searchFn]="customZIPSearchFn"
        placeholder="Enter ZIP"
        appendTo="body"
        (clear)="onClear()"
        (search)="onSearch($event, 'code')"
        (scrollToEnd)="onScrollToEnd('code')"
        (change)="onChangeZipCode($event)"
        [virtualScroll]="true"
        [loading]="isZipCodesLoading"
        [class.is-invalid]="
          addressFormGroup.get('zipcode')?.touched &&
          addressFormGroup.get('zipcode')?.invalid
        "
      >
        <ng-template ng-label-tmp let-item="item">
          <div [attr.title]="item.city">
            {{ item.code }}
          </div>
        </ng-template>
        <ng-template
          let-item="item"
          let-search="searchTerm"
          let-index="index"
          ng-option-tmp
        >
          <span [attr.title]="item.city">
            {{
              item.code && item.city && item.state
                ? item.code + ' (' + item.city + ' - ' + item.state + ')'
                : item.code
            }}
          </span>
        </ng-template>
      </ng-select>
    </div>

    <div class="">
      <div class="input-label">
        <span
          class="standart-text-required-symbol"
          *ngIf="isFieldRequired('city')"
          >*
        </span>
        City
      </div>

      <!-- [addTag]="true" -->
      <ng-select
        [items]="codes"
        [disabled]="addressFormGroup.disabled"
        [(ngModel)]="selectedCity"
        [ngModelOptions]="{ standalone: true }"
        placeholder="Enter City"
        [compareWith]="compareFn"
        [searchFn]="customCitySearchFn"
        bindValue="code"
        appendTo="body"
        (clear)="onClear()"
        (search)="onSearch($event, 'city')"
        (scrollToEnd)="onScrollToEnd('city')"
        (change)="onChangeCity($event)"
        [virtualScroll]="true"
        [loading]="isZipCodesLoading"
        [class.is-invalid]="
          addressFormGroup.get('city')?.touched &&
          addressFormGroup.get('city')?.invalid
        "
      >
        <ng-template ng-label-tmp let-item="item">
          <div [title]="item.city">
            {{ item.city }}
          </div>
        </ng-template>
        <ng-template
          ng-option-tmp
          let-item="item"
          let-search="searchTerm"
          let-index="index"
        >
          {{
            item.code && item.city && item.state
              ? item.city + ' (' + item.state + ' - ' + item.code + ')'
              : item.city
          }}
        </ng-template>
      </ng-select>
    </div>

    <div>
      <div class="input-label">
        <span
          class="standart-text-required-symbol"
          *ngIf="isFieldRequired('state')"
          >*
        </span>
        state
      </div>

      <!-- formControlName="state" -->
      <ng-select
        [disabled]="addressFormGroup.disabled"
        [items]="states$ | async"
        [(ngModel)]="selectedState"
        [ngModelOptions]="{ standalone: true }"
        placeholder="Enter State"
        bindLabel="code"
        bindValue="code"
        appendTo="body"
        [virtualScroll]="true"
        (change)="onChangeState($event)"
      >
      </ng-select>
    </div>
  </div>
</div>
